
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import PendoDivider from './pendo-divider.js';

var script = {
  name: 'PendoGuideElementTypeAction',
  components: {
    PendoIcon,
    PendoDivider
  },
  props: {
    uiElements: {
      type: Array,
      required: true,
      validator: elems => elems.every(el => el.name)
    },
    iconSize: {
      type: Number,
      default: 14
    }
  },
  methods: {
    showDivider(index) {
      const hasMoreThanOneElement = this.uiElements.length > 1;
      const isIndexAtTheLastElement = index === this.uiElements.length - 1;
      return hasMoreThanOneElement && !isIndexAtTheLastElement;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-guide-elements-types-actions"
  }, _vm._l(_vm.uiElements, function (ref, index) {
    var name = ref.name;
    var icon = ref.icon;
    return _c('div', {
      key: name,
      staticClass: "pendo-guide-element-types-actions"
    }, [icon ? _c('pendo-icon', {
      staticClass: "pendo-guide-element-type-action-icon",
      attrs: {
        "type": icon,
        "size": _vm.iconSize
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pendo-guide-element-type-action-name"
    }, [_vm._v("\n            " + _vm._s(name) + "\n        ")]), _vm._v(" "), _vm.showDivider(index) ? _c('pendo-divider', {
      attrs: {
        "direction": "vertical",
        "stroke": "#DADCE5",
        "width": "16px",
        "height": "16px"
      }
    }) : _vm._e()], 1);
  }), 0);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-guide-element-type-action.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoGuideElementTypeAction = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoGuideElementTypeAction;
